import { useMediaQuery } from 'react-responsive';

export enum PlatformType {
  desktop,
  tablet,
  mobile,
}

const usePlatform = () :PlatformType => {
  const isDesktop: boolean = useMediaQuery({ query: '(min-width:1024px' });
  const isTablet: boolean = useMediaQuery({ query: '(min-width:768px) and (max-width:1023px)' });
  if (isDesktop) {
    return PlatformType.desktop;
  } if (isTablet) {
    return PlatformType.tablet;
  }
  return PlatformType.mobile;
};

export const useMobile = () :boolean => useMediaQuery({ query: '(max-width:767px)' });

export default usePlatform;
